// Port of api/fuel/app/classes/filter/search/games/rules/query/report_text.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'report_text',
	contains: function(rule, config, filter, data, query) {
		var keywords = Rule.getKeywords(Rule.value(rule))
		var opMap = Rule.operandMapped(rule, { '=': 'like', '!=': 'not like' })
		for (var i = 0; i < keywords.length; i++) {
			query.where('p.play_comment', opMap, '%' + keywords[i] + '%')
		}
	}
})
